import React, { Component } from "react";
import styled from "styled-components";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import RemoteTable from "../../../components/Common/RemoteTable";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  getUsersToList,
  addUser,
  deleteUser,
  setUsersToList
} from "../../../store/user/user-list/actions";
import {
  userPatchProfile,
} from "../../../store/user/actions";
import { getPositionsList } from "../../../store/positions/actions";
import AddUserModal from "./AddUserModal";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';
import DynamicFormFilters from '../../../components/forms/DynamicFormFilters';
import { showInfoMessage } from "../../../helpers/utils";

class Users extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
      viewAddBudget: false,
      activeFilters: {},
      positions: [],
      statuses: [
        {
          id: 'all',
          name: 'ALL',
        },
        {
          id: 'true',
          name: 'Active',
        }, {
          id: 'false',
          name: 'Inactive'
        }
      ],
      initial: true
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    let dataPositions = this.props.positions;
    dataPositions["sizePerPage"] = "0";
    this.props.getPositionsList(dataPositions);

    if (this.state.initial) {
      this.props.getUsersToList({
        is_active: '',
        page: 1,
      });
    }

    this.setState({
      activeFilters: {
        is_active: '',
      },
      initial: false,
    });

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.positions !== prevProps.positions) {
      this.props.positions.results.map(i => {
        this.state.positions.push({
          label: i.title,
          value: i.id,
        });
      });
    }
  }

  componentWillUnmount() {
    this.props.setUsersToList({
      ...this.props.data,
      search: '',
      ordering: '',
      page: 1,
    })
    this.setState({
      initial: true,
    });
  }

  handleTableChange = data => {
    this.props.getUsersToList({
      ...data,
      ...this.state.activeFilters,
    });
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddBudgetModal = () => {
    this.setState(prevState => ({
      viewAddBudget: !prevState.viewAddBudget,
    }));
  };

  render() {
    const onClickRow = (e, row) => {
      this.props.history.push(`/profile/${row.id}`);
    };

    const showHRStatusFormatter = (cell, row, rowIndex, formatExtraData) => {
      const onClickChangeStatus = () => {
        if (this.props.permissions["is_admin"]) {
          this.handleChangeDeleteAlert({
            title: `Show in HR report`,
            confirmBtnText: `Change`,
            confirmBtnBsStyle: 'primary',
            message: `Do you really want the user "${row.first_name + " " + row.last_name}" data to be ${!row.show_in_hr_report ? 'hidden' : 'displayed'} in the HR report??`,
            onConfirm: async () => {
              await this.props.userPatchProfile(row.id, {
                show_in_hr_report: `${!row.show_in_hr_report}`,
                username: `${row.username}`
              }, 'update_from_table')
              this.handleChangeDeleteAlert(null);
            },
          });
        } else {
          showInfoMessage("You don't have permissions for this action");
        }

      };

      return <InputForm className="form-check form-switch form-switch-lg" onClick={onClickChangeStatus}>
        <input
          type="checkbox"
          className={`form-check-input ${row.show_in_hr_report ? 'bg-success border-success' : ''} pointer`}
          id="customSwitchsizelg"
          checked={row.show_in_hr_report}
        />
        <span className={`span-status ${row.show_in_hr_report ? 'active' : ''}`}>
          {row.show_in_hr_report ? 'Active' : 'Inactive'}
        </span>
      </InputForm>
    };

    const statusFormatter = (cell, row, rowIndex, formatExtraData) => {
      const onClickChangeStatus = () => {
        if (this.props.permissions["is_admin"]) {
          this.handleChangeDeleteAlert({
            title: `Change status`,
            confirmBtnText: `Change`,
            confirmBtnBsStyle: 'primary',
            message: `Are you sure want to change user status for "${row.first_name + " " + row.last_name}"?`,
            onConfirm: async () => {
              await this.props.userPatchProfile(row.id, {
                is_active: `${!row.is_active}`,
                username: `${row.username}`
              }, 'update_from_table')
              this.handleChangeDeleteAlert(null);
              // this.props.getUsersToList({
              //   ...this.props.data,
              //   ...this.state.activeFilters,
              // });
            },
          });
        } else {
          showInfoMessage("You don't have permissions for this action");
        }

      };

      return <InputForm className="form-check form-switch form-switch-lg" onClick={onClickChangeStatus}>
        <input
          type="checkbox"
          className={`form-check-input ${row.is_active ? 'bg-success border-success' : ''} pointer`}
          id="customSwitchsizelg"
          checked={row.is_active}
        />
        <span className={`span-status ${row.is_active ? 'active' : ''}`}>
          {row.is_active ? 'Active' : 'Inactive'}
        </span>
      </InputForm>
    };

    const legalNameFormatter = (cell, row, label) => {
      return (
        <LegalNameLink onClick={e => onClickRow(e, row)}>
          {row[label]}
        </LegalNameLink>
      );
    };

    const positionFormatter = (cell, row) => {
      // let positions = [];
      // row.positions.map(i => {
      //   positions.push(i.title);
      // });
      return (
        <LegalNameLink onClick={e => onClickRow(e, row)}>
          {row?.positions_list || 'No find'}
          {/* {positions.length > 0 ? positions.join(", ") : ""} */}
        </LegalNameLink>
      );
    };

    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.first_name + " " + row.last_name}"!`,
          onConfirm: () => {
            this.props.deleteUser(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      return (
        <>
          {this.props.permissions["delete_usermodel"] && (
            <button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </button>
          )}
        </>
      );
    };

    const columns = this.props.permissions["is_admin"] ? [
      {
        dataField: "first_name",
        text: "First name",
        sort: true,
        formatter: (cell, row) => legalNameFormatter(cell, row, "first_name"),
      },
      {
        dataField: "last_name",
        text: "Last Name",
        sort: true,
        formatter: (cell, row) => legalNameFormatter(cell, row, "last_name"),
      },
      {
        dataField: "email",
        text: "Email",
        sort: true,
        formatter: (cell, row) => legalNameFormatter(cell, row, "email"),
      },
      {
        dataField: "position",
        text: "Position",
        sort: true,
        formatter: (cell, row) => positionFormatter(cell, row),
      },
      {
        dataField: "show_in_hr_report",
        src: 'show_in_hr_report',
        text: "Show in HR report",
        sort: true,
        formatter: showHRStatusFormatter,
      }, //show_in_hr_report
      {
        dataField: "is_active",
        src: 'is_active',
        text: "Status",
        sort: true,
        formatter: statusFormatter,
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ] : [
      {
        dataField: "first_name",
        text: "First name",
        sort: true,
        formatter: (cell, row) => legalNameFormatter(cell, row, "first_name"),
      },
      {
        dataField: "last_name",
        text: "Last Name",
        sort: true,
        formatter: (cell, row) => legalNameFormatter(cell, row, "last_name"),
      },
      {
        dataField: "email",
        text: "Email",
        sort: true,
        formatter: (cell, row) => legalNameFormatter(cell, row, "email"),
      },
      {
        dataField: "position",
        text: "Position",
        sort: true,
        formatter: (cell, row) => positionFormatter(cell, row),
      },
      {
        dataField: "is_active",
        src: 'is_active',
        text: "Status",
        sort: true,
        formatter: statusFormatter,
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    const onFiltersChange = (filters, type, status) => {
      this.setState({
        activeFilters: {
          ...this.state.activeFilters,
          ...filters,
          ...(filters['is_active']?.length > 0 && { is_active: filters['is_active'][0] }),
        },
      });

      if (!this.state.initial) {
        this.props.getUsersToList({
          ...this.props.data,
          ...this.state.activeFilters,
          ...filters,
          ...(filters['is_active']?.length > 0 && { is_active: filters['is_active'][0] }),
          page: 1,
        });
      }
    }

    const handleDateRangeChange = () => {
      return 0;
    }

    return (
      <React.Fragment>
        {this.state.viewAddBudget && (
          <AddUserModal
            toggle={this.toggleViewAddBudgetModal}
            isOpen={this.state.viewAddBudget}
            addUser={this.props.addUser}
            positions={this.state.positions}
          />
        )}

        <div className="page-content">
          <ModifiedMetaTags title="Users | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Users"
              link="/dashboard"
            />
            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText={this.state.deleteAlert.confirmBtnText || "Delete"}
                cancelBtnText="Cancel"
                confirmBtnBsStyle={this.state.deleteAlert.confirmBtnBsStyle || "danger"}
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <StyleP>{this.state.deleteAlert.message || 'Are you sure want to delete this user?'}</StyleP>
              </SweetAlert>
            )}

            <Row>
              <Col className="col-12">
                <DynamicFormFilters
                  filterDelay={10}
                  FilterContainerClass="users--filters"
                  onFiltersChange={onFiltersChange}
                  onDateRangeChange={handleDateRangeChange}
                  // isLoadingSelect={props.topReportsFiltersLoading}
                  disableFilterBy
                  // filtered_params={queryString.parse(
                  //   this.props.history.location.search
                  // )}
                  filtersFields={[
                    {
                      filterData: this.state.statuses,
                      title: "Status",
                      plug: "Status...",
                      filterType: "is_active",
                      hasSelectAll: false,
                      singleSelect: true,
                      defaultValue: this.state.statuses[0],
                      style: {
                        marginLeft: "auto",
                      },
                    },
                    {
                      filterData: this.props.positions?.results
                        ? this.props.positions?.results.map(i => {
                          return {
                            id: i.id,
                            name: i.title,
                          };
                        })
                        : [],
                      title: "Positions",
                      plug: "Positions...",
                      filterType: "positions",
                      customWidth: '230px',
                    },
                  ]}
                  filtered_by={["is_active", "positions"]}
                  // filtered_params={"all"}
                  selectedDate={[]}
                  dateFilters={[
                  ]}
                />
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                      {this.props.permissions["add_usermodel"] && (
                        <Button
                          type="button"
                          color="success"
                          className="btn-rounded mb-2 me-2"
                          onClick={this.toggleViewAddBudgetModal}
                        >
                          <i className="mdi mdi-plus me-1" /> Add user
                        </Button>
                      )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const InputForm = styled.div`
  cursor: pointer;
  width: 60px;
  height: 25px;

  .form-check-input {
    cursor: pointer;
    width: 60px;
    height: 25px;
  }

  .span-status {
    position: absolute;
    right: 6.2px;
    top: 2px;
    font-size: 7.5px;
    color: #919191;
    font-weight: 600;

    &.active {
          position: absolute;
        left: 8px;
        top: 2px;
        font-size: 7.5px;
        color: #fff;
        font-weight: 600;
    }
}
`
const StyleP = styled.p`
  text-wrap: balance;
`

const LegalNameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

Users.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.number.isRequired,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  positions: PropTypes.shape({
    sizePerPage: PropTypes.any,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  permissions: PropTypes.object.isRequired,
  addUser: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
  getUsersToList: PropTypes.func.isRequired,
  getPositionsList: PropTypes.func.isRequired,
  userPatchProfile: PropTypes.func.isRequired,
  setUsersToList: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  data: state.UsersList.data,
  positions: state.Positions.data,
  permissions: state.User.permissions,
  loading: state.UsersList.loading,
});

export default connect(mapStateToProps, {
  getUsersToList,
  setUsersToList,
  addUser,
  deleteUser,
  getPositionsList,
  userPatchProfile
})(Users);
